import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { CATEGORY_LABELS, type Program } from '@/data/hooks/usePrograms';
import { countdownLabel, urgencyTier } from '@/lib/programStatus';

export function ExpiringRail({ programs }: { programs: Program[] }) {
  const expiring = programs
    .filter(p => {
      const t = urgencyTier(p);
      return t === 'soon' || t === 'final';
    })
    .sort((a, b) => (a.expiry_date ?? '').localeCompare(b.expiry_date ?? ''));

  if (expiring.length === 0) return null;

  return (
    <div>
      <h2 className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-yellow-400">
        <AlertTriangle className="h-4 w-4" /> Expiring soon
      </h2>
      <div className="flex gap-3 overflow-x-auto pb-1">
        {expiring.map(p => {
          const isFinal = urgencyTier(p) === 'final';
          return (
            <Link
              key={p.id}
              to={`/programs/${p.id}`}
              className={`group min-w-[260px] shrink-0 rounded-xl border p-4 backdrop-blur-sm transition hover:scale-[1.01] ${
                isFinal
                  ? 'border-red-500/40 bg-red-500/5 shadow-[0_0_24px_-6px_rgba(239,68,68,0.45)]'
                  : 'border-yellow-500/40 bg-yellow-500/5 shadow-[0_0_24px_-6px_rgba(234,179,8,0.45)]'
              }`}
            >
              <div className="flex items-center justify-between gap-2">
                <span className={`rounded px-2 py-0.5 text-[10px] font-bold uppercase ${
                  isFinal ? 'bg-red-500/20 text-red-300' : 'bg-yellow-500/20 text-yellow-300'
                }`}>
                  {isFinal ? 'Final days' : countdownLabel(p)}
                </span>
                <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-foreground" />
              </div>
              <div className="mt-2 line-clamp-2 text-sm font-semibold">{p.title}</div>
              <div className="mt-1 flex items-center justify-between text-[11px] text-muted-foreground">
                <span>{CATEGORY_LABELS[p.category]}</span>
                {isFinal && <span className="text-red-300">{countdownLabel(p)}</span>}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}